'use client';

import React from 'react';
import Image from 'next/image';
import { PortableText } from '@portabletext/react';
import { customRichTextComponent } from '@/sanity/sanityPortableText';
import { cn } from '@/lib/utils';
import quotes from '@/public/reviews/quotes.svg';
import stars from '@/public/reviews/stars.svg';
import { PortableTextBlock } from 'sanity';

export function ReviewCard({
  review,
  className,
  theme = 'green',
}: {
  review: {
    content: PortableTextBlock[];
    author: string;
  };
  className?: string;
  theme?: 'white' | 'green';
}) {
  return (
    <div
      className={cn(
        'rounded-[3rem] p-[5rem] flex flex-col',
        className,
        theme === 'green'
          ? 'bg-[#103037]'
          : 'bg-[#FCFDFD] border border-[#00000005] shadow-[-8px_6px_22px_0_rgba(56,_56,_56,_0.10),_0_-1.257px_5.027px_0_rgba(0,_0,_0,_0.10)_inset]',
      )}
    >
      <Image src={quotes} alt="quotes" className="w-[3.875rem] mb-[4.5rem]" />

      <div className="flex flex-col gap-[5.5rem]">
        {review.content && (
          <PortableText
            value={review.content}
            components={customRichTextComponent({
              block: {
                normal: ({ children }) => (
                  <p
                    className={cn(
                      'text-[2rem] lg:text-[2.5rem] leading-[160%] font-medium',
                      theme === 'green' ? 'text-white' : 'text-black',
                    )}
                  >
                    {children}
                  </p>
                ),
              },
            })}
          />
        )}
        <div className="flex items-center justify-between">
          {review.author && (
            <p
              className={cn(
                'text-[1.75rem] lg:text-[2.25rem] leading-[160%] font-normal mb-[-0.25rem]',
                theme === 'green' ? 'text-white/70' : 'text-black/70',
              )}
            >
              {review.author}
            </p>
          )}
          <Image src={stars} alt="stars" className="w-[15.125rem]" />
        </div>
      </div>
    </div>
  );
}
